var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _vm.missingAgentDetails
      ? _c("div", { staticClass: "col-12" }, [
          _c(
            "p",
            {
              staticClass:
                "bg-danger d-block mb-3 px-4 py-1 text-center text-white",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("direct-to-lender.participants.missingAgentNote")
                  ) +
                  "\n    "
              ),
            ]
          ),
        ])
      : !_vm.isOwner
      ? _c("div", { staticClass: "col-12" }, [
          _c(
            "p",
            { staticClass: "bg-clear-gray d-block mb-3 px-4 py-1 text-center" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("direct-to-lender.participants.agentNote")) +
                  "\n    "
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _c(
        "form",
        {
          attrs: { id: "agent-form" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
            },
          },
        },
        [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col-12 col-md-6" }, [
              _c("h6", { staticClass: "form-title font-sm" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("account.givenName")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _vm.agent.givenName
                ? _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.agent.givenName) +
                        "\n          "
                    ),
                  ])
                : _c("p", [_c("br")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-6" }, [
              _c("h6", { staticClass: "form-title font-sm" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("account.familyName")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _vm.agent.familyName
                ? _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.agent.familyName) +
                        "\n          "
                    ),
                  ])
                : _c("p", [_c("br")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-12 col-md-6" }, [
              _c("h6", { staticClass: "form-title font-sm" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("account.email")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _vm.agent.email
                ? _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.agent.email) +
                        "\n          "
                    ),
                  ])
                : _c("p", [_c("br")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-6" }, [
              _c("h6", { staticClass: "form-title font-sm" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("account.phoneNumber")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _vm.agent.phoneNumber
                ? _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.agent.phoneNumber) +
                        "\n          "
                    ),
                  ])
                : _c("p", [_c("br")]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row align-items-start" },
            [
              _c("div", { staticClass: "col-md-6 col-12" }, [
                _c("h6", { staticClass: "form-title font-sm" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("direct-to-lender.participants.brokerageName")
                      ) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _vm.agent.brokerageName
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.agent.brokerageName) +
                          "\n          "
                      ),
                    ])
                  : _c("p", [_c("br")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 col-12" }, [
                _c("h6", { staticClass: "form-title font-sm" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t(
                          "direct-to-lender.participants.agentLicenseRegistrationNumber"
                        )
                      ) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _vm.filogixDetails.licenseRegistrationNumber
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.filogixDetails.licenseRegistrationNumber) +
                          "\n          "
                      ),
                    ])
                  : _c("p", [_c("br")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6 col-12" }, [
                _c("h6", { staticClass: "form-title font-sm" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t(
                          "direct-to-lender.participants.brokerageLicenseRegistrationNumber"
                        )
                      ) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _vm.filogixDetails.licenseBrokerageNumber
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.filogixDetails.licenseBrokerageNumber) +
                          "\n          "
                      ),
                    ])
                  : _c("p", [_c("br")]),
              ]),
              _vm._v(" "),
              _c(
                "field",
                {
                  attrs: {
                    "size-class": "col-md-6 col-12",
                    title: _vm.$t(
                      "direct-to-lender.participants.expertProfileNumber"
                    ),
                    "container-class": "w-100",
                    icon: "fa-info-circle",
                    "icon-tooltip": _vm.$t(
                      "direct-to-lender.participants.youCanFindThisInExpert"
                    ),
                  },
                },
                [
                  _c("material-input", {
                    attrs: {
                      name: "expert-profile-number",
                      "class-name": "fe-num-field",
                      "no-label": "",
                      placeholder: _vm.$t(
                        "direct-to-lender.participants.expertProfileNumber"
                      ),
                      disabled: _vm.loadingDetails || !_vm.isOwner,
                      label: _vm.$t(
                        "direct-to-lender.participants.expertProfileNumber"
                      ),
                      "hidden-label": "",
                      required: "",
                      "label-for": "expert-profile-number",
                    },
                    model: {
                      value: _vm.localFilogixDetails.expertProfileNumber,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFilogixDetails,
                          "expertProfileNumber",
                          $$v
                        )
                      },
                      expression: "localFilogixDetails.expertProfileNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row align-items-end" },
            [
              _c(
                "field",
                {
                  attrs: {
                    "size-class": "col-12",
                    title: _vm.$t(
                      "direct-to-lender.participants.brokerageAddress"
                    ),
                    "icon-tooltip": _vm.$t(
                      "direct-to-lender.participants.enterBrokerageAddress"
                    ),
                    icon: "fa-info-circle",
                  },
                },
                [
                  _c("address-section", {
                    attrs: {
                      address: _vm.agent.address,
                      "custom-expressions": _vm.addressCustomExpressions,
                      "validator-context": _vm.$v,
                      disabled: !_vm.isOwner,
                    },
                    on: {
                      change: function ($event) {
                        _vm.agent.address = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-end" }, [
            _c("div", { staticClass: "col-auto" }, [
              _vm.isOwner
                ? _c(
                    "button",
                    {
                      ref: "submitButton",
                      staticClass: "btn btn-primary agent-form submit-changes",
                      attrs: { disabled: _vm.$v.$invalid },
                      on: { click: _vm.handleSubmit },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("global.words.save")) +
                          "\n          "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }